export default __webpack_public_path__ + "static/media/roadmap-banner-tracks.8e943d37.svg";